module.exports = __webpack_public_path__ + "media/images/icons/cm-contact-form/call-b980b0e088e613bd47fccf2739fe5fb8.svg";